/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ChannelWorkingHoursAdminDto } from '../models/ChannelWorkingHoursAdminDto';
import type { PutChannelManualStatusRequestAdmin } from '../models/PutChannelManualStatusRequestAdmin';
import type { PutChannelShiftsRequestAdmin } from '../models/PutChannelShiftsRequestAdmin';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class ChannelWorkingHoursService {
    /**
     * **Required Policy:** `ViewChannelWorkingHours`
     * @returns ChannelWorkingHoursAdminDto OK
     * @throws ApiError
     */
    public static getChannelWorkingHoursAdmin({
        channelId,
        regionId,
    }: {
        channelId: number,
        regionId: number,
    }): CancelablePromise<ChannelWorkingHoursAdminDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/admin/v1/channelworkinghours/{channelId}/regions/{regionId}',
            path: {
                'channelId': channelId,
                'regionId': regionId,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ManageChannelWorkingHours`
     * @returns any OK
     * @throws ApiError
     */
    public static putChannelShiftsAdmin({
        channelId,
        regionId,
        requestBody,
    }: {
        channelId: number,
        regionId: number,
        requestBody?: PutChannelShiftsRequestAdmin,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/admin/v1/channelworkinghours/{channelId}/regions/{regionId}/shifts',
            path: {
                'channelId': channelId,
                'regionId': regionId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ManageChannelWorkingHours`
     * @returns any OK
     * @throws ApiError
     */
    public static putChannelManualStatusAdmin({
        channelId,
        regionId,
        requestBody,
    }: {
        channelId: number,
        regionId: number,
        requestBody?: PutChannelManualStatusRequestAdmin,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/admin/v1/channelworkinghours/{channelId}/regions/{regionId}/status',
            path: {
                'channelId': channelId,
                'regionId': regionId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
}
